var map = {
	"./ADA.svg": 731,
	"./BCH.svg": 732,
	"./BNB.svg": 733,
	"./BTC.svg": 734,
	"./CHZ.svg": 735,
	"./DASH.svg": 736,
	"./DOGE.svg": 737,
	"./DOT.svg": 738,
	"./ETC.svg": 739,
	"./ETH.svg": 740,
	"./EUR.svg": 741,
	"./GBP.svg": 742,
	"./LINK.svg": 743,
	"./LTC.svg": 744,
	"./MATIC.svg": 745,
	"./MKR.svg": 746,
	"./SHIB.svg": 747,
	"./SOL.svg": 748,
	"./TRX.svg": 749,
	"./UNI.svg": 750,
	"./USD.svg": 751,
	"./USDT.svg": 752,
	"./XLM.svg": 753,
	"./XMR.svg": 754,
	"./XRP.svg": 755,
	"./documents.svg": 756
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 730;